import { Component, Input, Injector } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { PatientLayoutComponent } from '../patient-layout/patient-layout.component';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';
import { DialogService } from 'src/modules/base/components/dialog/dialog.service';

@Component({
    selector: 'app-deposit-refund-banner',
    templateUrl: '../patient-layout/patient-layout.component.html',
    styleUrls: ['../patient-layout/patient-layout.component.scss'],
    standalone: false
})
export class DepositRefundBannerComponent extends PatientLayoutComponent {
  @Input() dataForCard: Array<any>;
  admission_id:any;
  @Input() bannerJson: any;

  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public alerts: AlertsService,
    public baseService: BaseService,
    public smartModalService: SmartModalService,
    public rolePermissionService: RolePermissionService,
    public communicationService: CommunicationService,
    public preferenceService: PreferenceService,
    public utilService: UtilService,
    public dialogService?: DialogService,
    public appService?: AppService
  ) {
    super(injector, router, route, alerts, baseService, smartModalService, communicationService, rolePermissionService,preferenceService, utilService, dialogService,appService) // Fixes Add Dialogservice
  }

  ngOnInit() {
    console.log("dataForCard ",this.dataForCard);
    if (this.route.snapshot.queryParams && this.route.snapshot.queryParams.sponsorRefund != undefined && this.route.snapshot.queryParams.sponsorRefund != false) {
      let sponsorBanner = JSON.parse(sessionStorage.getItem('currentData'))
      this.dataForCard[0] = sponsorBanner;
    }
    else{
    if(this.dataForCard && this.dataForCard.length > 0){
      sessionStorage.setItem("currentDatacard", JSON.stringify(this.dataForCard[0]));
      var data = this.dataForCard[0];
      if(data.deposit_for == 'UHID'){
        let griddata = {
          "search":data.uhId,
          "query_id": 'GET_PAGE'
        }
        this.getDataFromAPI(data, griddata, 'patient', 'patient-registration');
      }
      else if(data.deposit_for == 'ADMISSIONID' || data.admissionId || data.identifier){
        if(data.admissionId == undefined){
          data.admissionId = data.identifier;
        }
        let griddata = {
          "args": "admissionId:" + data.admissionId,
          "query_id": 'BILLING_DETAILS'
        }
        this.getData(data, griddata, 'billing_details', 'billing');
      }
      else if(data.encounter_id != undefined) {
        let griddata = {
          "args": "encounter_id:" + data.encounter_id,
          "query_id": 'GET_DATA_BY_ENCOUNTER_ID'
        }
        this.getData(data, griddata, 'encounter_ipAdmission', 'adt');
      }
    }
  }
    console.log("BannerJson is ", this.bannerJson);
    super.ngOnInit();
  }
  getDataFromAPI(data, gridData, resource, application){
    this.baseService.getWithPage(gridData, resource, application, 'GET_PAGE').subscribe(result => {
      if(result.resource && result.resource.length > 0){
        this.dataForCard[0] ={...data, ...result.resource[0]};
      }else{
        this.dataForCard[0] = data;
      }
      console.log("CardData ",this.dataForCard[0]);
    });
  }
  getData(data, gridData, resource, application){
    this.baseService.getData(gridData, "", resource, application).subscribe(result => {
      if(result.resource && result.resource.length > 0){
        this.dataForCard[0] ={...data, ...result.resource[0]};
      }else{
        this.dataForCard[0] = data;
      }
      console.log("CardData ",this.dataForCard[0]);
    });
  }
  // expandCards(){
  //   if(this.expandCard)
  //     this.expandCard = false;
  //   else
  //     this.expandCard = true;
  // }
}